export const projects = [
    {
      title: "Assassin's Creed Shadows",
      subtitle: "C++, Ubisoft Anvil",
      thumbnail: "./img/acshadows-thumbnail.jpg",
      image: "/img/acshadows-banner.png",
      category: "Games",
    },
    {
      title: "After School",
      subtitle: "C++, Unreal Engine",
      thumbnail: "./img/AfterSchool-thumbnail.png",
      image: "/img/afterschool-banner.jpg",
      category: "Games",
    },
    {
      title: "Droid Rush",
      subtitle: "C++, Unreal Engine",
      thumbnail: "./img/droidrush-thumbnail.jpg",
      image: "/img/droidrush-banner.jpg",
      category: "Games",
    },
    {
      title: "Lux",
      subtitle: "C++, Unreal Engine",
      thumbnail: "./img/lux-thumbnail.jpg",
      image: "/img/lux-banner.jpg",
      category: "Games",
    },
    {
      title: "ALKA",
      subtitle: "C++, Unreal Engine",
      thumbnail: "./img/alka-thumbnail.jpg",
      image: "/img/alka-banner.jpg",
      category: "Games",
    },
    {
      title: "Time Swap",
      subtitle: "C#, Unity",
      thumbnail: "./img/timeswap-thumbnail.jpg",
      image: "/img/timeswap-banner.jpg",
      category: "Games",
    },
    {
      title: "Centre National d'Exposition",
      subtitle: "HTML/CSS, jQuery, PHP, MySQL",
      thumbnail: "./img/cne-thumbnail.jpg",
      image: "/img/cne-banner.jpg",
      category: "Others",
    }
  ];